const $ = window.$;

export default class Dinewith {
  constructor() {
    this.state = {
      collapse: true,
    }
  }
}


var fukuoka_img ='<figure><img src="/co/assets/img/pc/dinewith/fukuoka_01.png" alt=""></figure><ul><li><img src="/co/assets/img/pc/dinewith/fukuoka_02.png" alt=""></li><li><img src="/co/assets/img/pc/dinewith/fukuoka_03.png" alt=""></li></ul>';
var fukuoka_title ='<p>One of Fukuoka\'s best-loved, most nutritious traditional dishes</p><h2><i>Motsu</i> (offal) hot pot (Region: Fukuoka Prefecture)</h2>';
var fukuoka_txt ='<p><i>Motsu</i> hot pot is made primarily with beef innards (short intestine, long intestine, tripe, etc.). These are typically cooked together with plenty of chives, cabbage and other vegetables, in a soup seasoned with garlic and chilies.<br>The garlic and chili bring out the savory umami of the innards and the sweetness of the vegetables, for a flavor that matches perfectly with shochu and will have you coming back for more!</p>';
var fukuoka_recommend ='<figure><img src="/co/assets/img/pc/dinewith/fukuoka_04.png" alt="">Kuro Kirishima</figure>';

var saga_img ='<figure><img src="/co/assets/img/pc/dinewith/saga_01.png" alt=""></figure><ul><li><img src="/co/assets/img/pc/dinewith/saga_02.png" alt=""></li><li><img src="/co/assets/img/pc/dinewith/saga_03.png" alt=""></li></ul>';
var saga_title ='<p>Made with beautifying hot spring water, this tofu melts on the tongue</p><h2>Hot Spring Heated Tofu (Region: Saga Prefecture)</h2>';
var saga_txt ='<p>Made from soybeans, tofu is one of Japan\'s traditional foods.<br>This dish features tofu simmered in hot spring water from Ureshino Onsen in Saga, known as one of Japan\'s three hot springs most famous for their skin beautifying properties. <br>The tofu has a smooth, mellow texture that melts on the tongue, filling the mouth with the umami of soy. Enjoy along with the rich "white soup" that distinguishes this dish. The hot spring waters of Ureshino Onsen not only taste good, but are said to invigorate gastrointestinal and liver function as well. </p>';
var saga_recommend ='<figure><img src="/co/assets/img/pc/dinewith/saga_04.png" alt="">Shiro Kirishima</figure>';

var nagasaki_img ='<figure><img src="/co/assets/img/pc/dinewith/nagasaki_01.png" alt=""></figure><ul><li><img src="/co/assets/img/pc/dinewith/nagasaki_02.png" alt=""></li><li><img src="/co/assets/img/pc/dinewith/nagasaki_03.png" alt=""></li></ul>';
var nagasaki_title ='<p>A jewel-like, exquisite delicacy</p><h2><i>Karasumi</i> (dried mullet roe)  (Region: Nagasaki Prefecture)</h2>';
var nagasaki_txt ='<p>In Europe, <i>karasumi</i> is known as <i>bottarga</i>. A Nagasaki delicacy, karasumi is made from the roe of the gray mullet, which are brined and then rinsed before being sun-dried. It has a chewy texture and a distinctive, savory flavor, with just the right amount of saltiness to make it a perfect companion to shochu. <br>Karasumi can be enjoyed lightly seared, and tastes just as great broken up and added to a pasta dish. </p>';
var nagasaki_recommend ='<figure><img src="/co/assets/img/pc/dinewith/nagasaki_04.png" alt="">Aka Kirishima</figure>';

var oita_img ='<figure><img src="/co/assets/img/pc/dinewith/oita_01.png" alt=""></figure><ul><li><img src="/co/assets/img/pc/dinewith/oita_02.png" alt=""></li><li><img src="/co/assets/img/pc/dinewith/oita_03.png" alt=""></li></ul>';
var oita_title ='<p>A turtle hot pot dish rich in collagen</p><h2><i>Suppon</i> (soft-shelled turtle) hot pot (Region: Oita Prefecture)</h2>';
var oita_txt ='<p><i>Suppon</i>, or soft-shelled turtle, has appeared in the cuisines of China and Japan since ancient times. Served in a hot pot preparation, the rich, savory flavor of the suppon melts into a deeply satisfying soup that deserves to be enjoyed to the very last drop.<br>In addition to collagen, suppon hot pot is also rich in amino acids and minerals, and is increasingly highlighted and popular as a dish effective for both beauty and good health.</p>';
var oita_recommend ='<figure><img src="/co/assets/img/pc/dinewith/oita_04.png" alt="">Shiro Kirishima</figure>';

var kumamoto_img ='<figure><img src="/co/assets/img/pc/dinewith/kumamoto_01.png" alt=""></figure><ul><li><img src="/co/assets/img/pc/dinewith/kumamoto_02.png" alt=""></li><li><img src="/co/assets/img/pc/dinewith/kumamoto_03.png" alt=""></li></ul>';
var kumamoto_title ='<p>A traditional Kumamoto dish with a 400-year history</p><h2><i>Karashi renkon</i> (Japanese mustard-stuffed lotus root)  (Region: Kumamoto Prefecture)</h2>';
var kumamoto_txt ='<p><i>Renkon</i> is the edible rhizome, or root portion, of the lotus plant. It has a crunchy consistency, and is recognizable from its many holes. In this dish, lotus root is par-boiled and the holes stuffed with a combination of miso for seasoning and <i>karashi</i>, which has a pungent spiciness similar to mustard. The lotus root is then deep-fried.<br>Sweet potatoes shochu goes down easily with the mildly sweet, crisp lotus root and the sharp tang of the karashi miso.</p>';
var kumamoto_recommend ='<figure><img src="/co/assets/img/pc/dinewith/kumamoto_04.png" alt="">Kuro Kirishima</figure>';

var miyazaki_img ='<figure><img src="/co/assets/img/pc/dinewith/miyazaki_01.png" alt=""></figure><ul><li><img src="/co/assets/img/pc/dinewith/miyazaki_02.png" alt=""></li><li><img src="/co/assets/img/pc/dinewith/miyazaki_03.png" alt=""></li></ul>';
var miyazaki_title ='<p>Chicken thigh meat with a smoky fragrance and irresistible texture</p><h2>Charcoal-grilled chicken (Region: Miyazaki Prefecture)</h2>';
var miyazaki_txt ='<p>Chicken fat is added to a charcoal fire, and as the flames rise, salt-seasoned chicken thighs are quickly seared to perfection. This cooking method has been known in Miyazaki since ancient times. Chefs in Miyazaki use local free-range chicken, knowing they can rely on the flavor.<br>The tender, juicy meat has a firm, almost elastic consistency. To bring out that texture and the sweet, smoky fragrance of the meat, the only seasoning used is salt. </p>';
var miyazaki_recommend ='<figure><img src="/co/assets/img/pc/dinewith/miyazaki_04.png" alt="">Kuro Kirishima</figure>';

var kagoshima_img ='<figure><img src="/co/assets/img/pc/dinewith/kagoshima_01.png" alt=""></figure><ul><li><img src="/co/assets/img/pc/dinewith/kagoshima_02.png" alt=""></li><li><img src="/co/assets/img/pc/dinewith/kagoshima_03.png" alt=""></li></ul>';
var kagoshima_title ='<p>A rich, deep caramel-colored pork dish</p><h2><i>Tonkotsu</i> (seasoned pork ribs)  (Region: Kagoshima Prefecture)</h2>';
var kagoshima_txt ='<p>In Kagoshima, <i>tonkotsu</i> refers to a traditional local dish made with bone-in pork rib meat, which is typically seasoned with miso, dark brown sugar and sweet potatoes shochu. The sweetness of these three ingredients combines with the richness of the pork to create a deep, concentrated flavor. <br>Tonkotsu goes well with rice, but is also delicious enjoyed as an appetizer with your favorite sweet potatoes shochu.</p>';
var kagoshima_recommend ='<figure><img src="/co/assets/img/pc/dinewith/kagoshima_04.png" alt="">Kuro Kirishima</figure>';

var okinawa_img ='<figure><img src="/co/assets/img/pc/dinewith/okinawa_01.png" alt=""></figure><ul><li><img src="/co/assets/img/pc/dinewith/okinawa_02.png" alt=""></li><li><img src="/co/assets/img/pc/dinewith/okinawa_03.png" alt=""></li></ul>';
var okinawa_title ='<p>Firm, fresh fish and the rich taste of liver in a miso-based preparation</p><h2><i>Abasaa jiru</i> (porcupinefish soup)  (Region: Okinawa Prefecture)</h2>';
var okinawa_txt ='<p>In the Okinawan dialect, <i>abasaa</i> is the word for the porcupinefish, a relative of the <i>fugu</i>, or puffer fish, a more luxurious food item. The flesh is firm and mild. <i>Abasaa jiru</i> has long been a popular way of enjoying this fish in Okinawa. <br>This rich soup is seasoned with miso and the deep, savory umami of the fish\'s liver, while the flesh is firm and chewy. In cold weather, the liver adds an extra layer of richness. </p>';
var okinawa_recommend ='<figure><img src="/co/assets/img/pc/dinewith/okinawa_04.png" alt="">Shiro Kirishima</figure>';


$('.fukuoka').on({
  'click':function(){
    $(this).blur() ;  //ボタンからフォーカスを外す
    if($('#modal-ol')[0]) return false ;
    $('body').append('<div id="modal-ol"></div>');

    $('#modal-ol').fadeIn('slow');
    $('.modal-img').append(fukuoka_img);
    $('.modal-title').append(fukuoka_title);
    $('.modal-img-sp').append(fukuoka_img);
    $('.modal-detail').append(fukuoka_txt);
    $('.modal-drink').append(fukuoka_recommend);

    centeringModalSyncer();
    $('.dine-modal-wrap').fadeIn('slow');

    $('.dine-modal-wrap,.modal-close,#modal-ol').unbind().click(function(){
      $('.dine-modal-wrap,#modal-ol').fadeOut('slow',function(){
        $('#modal-ol').remove();
        modalClear();
      });
    });
  }
});

$('.saga').on({
  'click':function(){
    $(this).blur() ;  //ボタンからフォーカスを外す
    if($('#modal-ol')[0]) return false ;
    $('body').append('<div id="modal-ol"></div>');

    $('#modal-ol').fadeIn('slow');
    $('.modal-img').append(saga_img);
    $('.modal-title').append(saga_title);
    $('.modal-img-sp').append(saga_img);
    $('.modal-detail').append(saga_txt);
    $('.modal-drink').append(saga_recommend);

    centeringModalSyncer();
    $('.dine-modal-wrap').fadeIn('slow');

    $('.dine-modal-wrap,#modal-ol,.modal-close').unbind().click(function(){
      $('.dine-modal-wrap,#modal-ol').fadeOut('slow',function(){
        $('#modal-ol').remove();
        modalClear();
      });
    });
  }
});

$('.nagasaki').on({
  'click':function(){
    $(this).blur() ;  //ボタンからフォーカスを外す
    if($('#modal-ol')[0]) return false ;
    $('body').append('<div id="modal-ol"></div>');

    $('#modal-ol').fadeIn('slow');
    $('.modal-img').append(nagasaki_img);
    $('.modal-title').append(nagasaki_title);
    $('.modal-img-sp').append(nagasaki_img);
    $('.modal-detail').append(nagasaki_txt);
    $('.modal-drink').append(nagasaki_recommend);

    centeringModalSyncer();
    $('.dine-modal-wrap').fadeIn('slow');

    $('.dine-modal-wrap,#modal-ol,.modal-close').unbind().click(function(){
      $('.dine-modal-wrap,#modal-ol').fadeOut('slow',function(){
        $('#modal-ol').remove();
        modalClear();
      });
    });
  }
});

$('.kumamoto').on({
  'click':function(){
    $(this).blur() ;  //ボタンからフォーカスを外す
    if($('#modal-ol')[0]) return false ;
    $('body').append('<div id="modal-ol"></div>');

    $('#modal-ol').fadeIn('slow');
    $('.modal-img').append(kumamoto_img);
    $('.modal-title').append(kumamoto_title);
    $('.modal-img-sp').append(kumamoto_img);
    $('.modal-detail').append(kumamoto_txt);
    $('.modal-drink').append(kumamoto_recommend);

    centeringModalSyncer();
    $('.dine-modal-wrap').fadeIn('slow');

    $('.dine-modal-wrap,#modal-ol,.modal-close').unbind().click(function(){
      $('.dine-modal-wrap,#modal-ol').fadeOut('slow',function(){
        $('#modal-ol').remove();
        modalClear();
      });
    });
  }
});

$('.oita').on({
  'click':function(){
    $(this).blur() ;  //ボタンからフォーカスを外す
    if($('#modal-ol')[0]) return false ;
    $('body').append('<div id="modal-ol"></div>');

    $('#modal-ol').fadeIn('slow');
    $('.modal-img').append(oita_img);
    $('.modal-title').append(oita_title);
    $('.modal-img-sp').append(oita_img);
    $('.modal-detail').append(oita_txt);
    $('.modal-drink').append(oita_recommend);

    centeringModalSyncer();
    $('.dine-modal-wrap').fadeIn('slow');

    $('.dine-modal-wrap,#modal-ol,.modal-close').unbind().click(function(){
      $('.dine-modal-wrap,#modal-ol').fadeOut('slow',function(){
        $('#modal-ol').remove();
        modalClear();
      });
    });
  }
});

$('.miyazaki').on({
  'click':function(){
    $(this).blur() ;  //ボタンからフォーカスを外す
    if($('#modal-ol')[0]) return false ;
    $('body').append('<div id="modal-ol"></div>');

    $('#modal-ol').fadeIn('slow');
    $('.modal-img').append(miyazaki_img);
    $('.modal-title').append(miyazaki_title);
    $('.modal-img-sp').append(miyazaki_img);
    $('.modal-detail').append(miyazaki_txt);
    $('.modal-drink').append(miyazaki_recommend);

    centeringModalSyncer();
    $('.dine-modal-wrap').fadeIn('slow');

    $('.dine-modal-wrap,#modal-ol,.modal-close').unbind().click(function(){
      $('.dine-modal-wrap,#modal-ol').fadeOut('slow',function(){
        $('#modal-ol').remove();
        modalClear();
      });
    });
  }
});

$('.kagoshima').on({
  'click':function(){
    $(this).blur() ;  //ボタンからフォーカスを外す
    if($('#modal-ol')[0]) return false ;
    $('body').append('<div id="modal-ol"></div>');

    $('#modal-ol').fadeIn('slow');
    $('.modal-img').append(kagoshima_img);
    $('.modal-title').append(kagoshima_title);
    $('.modal-img-sp').append(kagoshima_img);
    $('.modal-detail').append(kagoshima_txt);
    $('.modal-drink').append(kagoshima_recommend);

    centeringModalSyncer();
    $('.dine-modal-wrap').fadeIn('slow');

    $('.dine-modal-wrap,#modal-ol,.modal-close').unbind().click(function(){
      $('.dine-modal-wrap,#modal-ol').fadeOut('slow',function(){
        $('#modal-ol').remove();
        modalClear();
      });
    });
  }
});

$('.okinawa').on({
  'click':function(){
    $(this).blur() ;  //ボタンからフォーカスを外す
    if($('#modal-ol')[0]) return false ;
    $('body').append('<div id="modal-ol"></div>');

    $('#modal-ol').fadeIn('slow');
    $('.modal-img').append(okinawa_img);
    $('.modal-title').append(okinawa_title);
    $('.modal-img-sp').append(okinawa_img);
    $('.modal-detail').append(okinawa_txt);
    $('.modal-drink').append(okinawa_recommend);

    centeringModalSyncer();
    $('.dine-modal-wrap').fadeIn('slow');

    $('.dine-modal-wrap,#modal-ol,.modal-close').unbind().click(function(){
      $('.dine-modal-wrap,#modal-ol').fadeOut('slow',function(){
        $('#modal-ol').remove();
        modalClear();
      });
    });
  }
});

//センタリングをする関数
function centeringModalSyncer(Mobile){

  //画面(ウィンドウ)の幅を取得し、変数[w]に格納
  var w = $(window).width();

  //画面(ウィンドウ)の高さを取得し、変数[h]に格納
  var h = $(window).height();

  //コンテンツ(.dine-modal)の幅を取得し、変数[cw]に格納
  var cw = $('.dine-modal').outerWidth();

  //コンテンツ(.dine-modal)の高さを取得し、変数[ch]に格納
  var ch = $('.dine-modal').outerHeight();

  //コンテンツ(.dine-modal)を真ん中に配置するのに、左端から何ピクセル離せばいいか？を計算して、変数[pxleft]に格納
  var pxleft = ((w - cw)/2);

  //コンテンツ(.dine-modal)を真ん中に配置するのに、上部から何ピクセル離せばいいか？を計算して、変数[pxtop]に格納
  var pxtop = ((h - ch)/2);

  //[.dine-modal]のCSSに[left]の値(pxleft)を設定
  if(w > 980) {
    $('.dine-modal').css({'left': pxleft + 'px'});
  }
  //[.dine-modal]のCSSに[top]の値(pxtop)を設定
  // $('.dine-modal').css({'top': pxtop + 'px'});


}


function modalClear(){
    $('.modal-img').empty();
    $('.modal-title').empty();
    $('.modal-img-sp').empty();
    $('.modal-detail').empty();
    $('.modal-drink').empty();
    $('.modal-drink').append('<h2>Recommended Products</h2>');
}



/** WEBPACK FOOTER **
 ** ./htdocs_dev/js/view/dinewith.js
 **/